import BannerParque from './BannerParque';
export default BannerParque;